import { FindWorkAreasQuery } from "@/types/gql/graphql";

import { z } from "zod";

export const formSchema = z.object({
  name: z.string().trim().min(1, { message: "Name is required" }),
  done: z.boolean(),
  cityId: z.string(),
});

export type WorkAreaProperties = z.infer<typeof formSchema>;

export type WorkArea = FindWorkAreasQuery["workAreas"][number];
